import React, {useEffect} from 'react';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import Width from '../../../assets/Width';

const ClubMarketOptions = ({
  onOptionClick,
  isForm = false,
  optionSelectedIndex,
  clubmarketOptions,
  isOwner,
}) => {
  const onClickOption = (item, index) => {
    if (isOwner && !isForm) {
      return;
    }
    onOptionClick(item, index);
  };
  return (
    <View style={{marginTop: 30, marginBottom: 48}}>
      {!isForm && (
        <Text style={globalFontStyle.appFontSmallText}>
          Select an option to proceed
        </Text>
      )}
      {isOwner && isForm && (
        <Text style={globalFontStyle.appFontSmallText}>
          Select the right settlement option
        </Text>
      )}
      {clubmarketOptions.map((item, index) => {
        const isSelected = isForm && optionSelectedIndex === item?.id;
        return (
          <TouchableOpacity
            key={index}
            style={[
              styles.optionBarStyle,
              isSelected ? {backgroundColor: Color.blue1} : {},
              {position: 'relative'},
            ]}
            onPress={() => onClickOption(item, index)}
            activeOpacity={0.8}>
            {!isForm && (
              <View
                style={[
                  styles.clubOptionPercent,
                  item?.poll_percent
                    ? {width: (Width.width - 27) * item?.poll_percent}
                    : {},
                ]}
              />
            )}
            <Text
              style={[
                styles.clubOptionTitle,
                isSelected ? {color: Color.bgWhite} : {},
              ]}>
              {' '}
              {item?.label}
            </Text>
            {item?.roi?.toFixed(2) && (
              <Text
                style={[
                  styles.clubOptionRoi,
                  isSelected ? {color: Color.bgWhite} : {},
                ]}>
                {' '}
                {(item?.roi * 100)?.toFixed(2)}%
              </Text>
            )}
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default ClubMarketOptions;

const styles = StyleSheet.create({
  optionBarStyle: {
    background: Color.bgWhite,
    borderWidth: 0.75,
    borderColor: '#c2c2c2',
    borderRadius: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  clubOptionTitle: {
    color: Color.black,
    paddingHorizontal: 20,
    paddingVertical: 14,
  },
  clubOptionRoi: {
    color: '#0a57ff',
    paddingHorizontal: 20,
    paddingVertical: 14,
  },
  clubOptionPercent: {
    position: 'absolute',
    backgroundColor: '#f2f6ff',
    height: 46,
  },
});
